import React from "react"
import { Card, CardContent, Divider, Stack, Typography } from "@mui/material"

interface UsageCardProps {
  productsThisMonth: number
  creditsRemaining: number
}

const UsageCard: React.FC<UsageCardProps> = ({ productsThisMonth, creditsRemaining }) => {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3, height: "100%", width: "100%" }}>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6" fontWeight={700}>
            Usage
          </Typography>
          <Divider />

          <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Products created this month
              </Typography>
              <Typography variant="body2" fontWeight={700}>
                {productsThisMonth}
              </Typography>
            </Stack>

            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                Credits remaining
              </Typography>
              <Typography
                variant="body2"
                fontWeight={700}
                color={creditsRemaining === 0 ? "error.main" : creditsRemaining <= 5 ? "warning.main" : "text.primary"}>
                {creditsRemaining}
              </Typography>
            </Stack>
          </Stack>

          <Typography variant="caption" color="text.secondary">
            Each AI image generated uses 1 credit. Credits never expire.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default UsageCard
